import { useCallback } from 'react'
import { useResourceList } from '@/components/admin/shared/hooks/use-resource'
import type { RouterOutputs } from '@/lib/trpc'
import { trpc } from '../../../../lib/trpc.js'

export interface ResourceItem {
  id: string
  title: string
  url: string
  type: string // "video", "article", "course", "book", "tool"
  description: string | null
  icon: string | null
}

const selectResources = (
  data: RouterOutputs['admin']['resources']['list'] | undefined,
): ResourceItem[] => data?.data ?? []

export function useResources() {
  const utils = trpc.useUtils()

  const invalidate = useCallback(() => {
    utils.admin.resources.list.invalidate()
  }, [utils])

  const {
    items: resources,
    loading,
    error,
    refresh,
  } = useResourceList({
    query: trpc.admin.resources.list.useQuery(),
    select: selectResources,
    invalidate,
  })

  const createMutation = trpc.admin.resources.create.useMutation({
    onSuccess: invalidate,
  })

  const createResource = async (data: {
    title: string
    url: string
    type: string
    description?: string
  }): Promise<ResourceItem> => {
    return createMutation.mutateAsync(data) as Promise<ResourceItem>
  }

  return { resources, loading, error, refresh, createResource }
}
